<template>
    <tr class="cursor-pointer">
        <TableCell truncate>
            <div class="flex">
                <div class="hidden lg:block mr-3">
                    <AvatarSm image="" :name="user.name" />
                </div>
                <div class="overflow-hidden">
                    <p class="font-medium truncate">{{ user.fullName }}</p>
                    <p class="ct-text-3 truncate">{{ user.email }}</p>
                </div>
            </div>
        </TableCell>
        <TableCell sm-hidden>
            <p class="ct-text-3">{{ orderDate }}</p>
        </TableCell>
        <TableCell sm-hidden>
            <p class="ct-text-3">{{ firstVisitDate }}</p>
        </TableCell>
        <TableCell sm-hidden>
            <p class="ct-text-3">{{ lastVisitDate }}</p>
        </TableCell>
        <TableCell text-right sm-hidden>
            <p class="ct-text-3">{{ user.numberOfVisits || "-" }}</p>
        </TableCell>
        <TableCell text-right sm-hidden>
            <p class="ct-text-3">{{ courseProgress }}</p>
        </TableCell>
        <!--        <TableCell text-right sm-hidden>
            <BadgeStatusSm :type="user.hasCertificate ? 'success' : 'error'">
                <span>{{
                    user.hasCertificate
                        ? $t("player.panel.certificates.yes")
                        : $t("player.panel.certificates.no")
                }}</span>
            </BadgeStatusSm>
        </TableCell>-->
    </tr>
</template>

<script>
import { i18n } from "@/i18n";
import moment from "moment";
import { TableCell } from "@easy/ui/tables";
import { AvatarSm } from "@easy/ui/avatars";
// import { BadgeStatusSm } from "@easy/ui/badges";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: {
        TableCell,
        AvatarSm,
        // BadgeStatusSm,
    },
    computed: {
        orderDate() {
            return moment(this.user.orderDate).format("DD.MM.YYYY");
        },
        firstVisitDate() {
            return this.user.firstVisitDate
                ? moment(this.user.firstVisitDate).locale(i18n.global.locale.value).fromNow()
                : "-";
        },
        lastVisitDate() {
            return this.user.lastVisitDate
                ? moment(this.user.lastVisitDate).locale(i18n.global.locale.value).fromNow()
                : "-";
        },
        courseProgress() {
            return this.user.courseProgress ? `${Math.round(this.user.courseProgress)}%` : "-";
        },
    },
};
</script>
